<ng-container *ngIf="question">
  <bepatient-question-title-v3
    [constraints]="question.constraints"
    [color]="color"
    [errors]="question.errors"
    [css]="question.css"
    [key]="question.key"
    [value]="value"
    [dirty]="dirty"
    [type]="question.controlType"
    [formGroup]="formGroup"
    [hasCondition]="question.hasCondition"
  >
  </bepatient-question-title-v3>

  <div [formGroup]="formGroup">
    <ion-list [formArrayName]="question.key">
      <ion-item *ngFor="let option of options; let i = index" lines="none">
        <!-- Toggle question lable is aligned right after toggle button -->
        <ion-toggle
          [id]="i"
          slot="start"
          [formControlName]="i"
          [attr.disabled]="question.disabled || question.readonly"
          [checked]="question.options[i].value"
          (ionChange)="isChecked()"
          [attr.aria-label]="question.options[i].key"
          labelPlacement="end"
        >
          {{ question.options[i].key }}
        </ion-toggle>
      </ion-item>
    </ion-list>
  </div>
</ng-container>
